<script>
import './style.scss';
import template from './template.html';
import axios from 'axios';
import {ChevronDownIcon, ChevronUpIcon, UploadIcon} from '../icons.js';
import {mapMutations} from "vuex";

export default {

  created () {
  },

  computed: {},

  methods: {
    ...mapMutations('ReviewerImportFormStore', [
      'toggleShowForm',
    ]),
    showReviewersForm () {
      this.$emit('toggle-form', {isVisible: true});
    },
    importReviewers () {
      this.toggleShowForm(true);
    }
  },

    template,

  data () {

    return {
        reviewers: [],

      isActive: false
      }
    },

  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    UploadIcon
  }
  };
</script>
